import * as React from 'react';
import { BPMSoundsGeneric } from '../generic';
import Carousel from './Carousel';
import { Divider } from './utility';
var BannerRenderer = function (props) {
    var _a = React.useState(), banner = _a[0], setBanner = _a[1];
    React.useEffect(function () {
        BPMSoundsGeneric.get().getBanner(props.location).then(function (banner) {
            setBanner(banner);
        });
    }, [props.location]);
    if (!banner) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Carousel, { banner: banner, onClick: props.onItemClick }),
        props.noDivider !== true && React.createElement(Divider, { small: true })));
};
export default BannerRenderer;
//# sourceMappingURL=Banner.js.map